import { PayloadAction } from '@reduxjs/toolkit';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

interface Payload {
  value: DTO__image_asset;
  key: keyof STATE__ui;
}

export const LOCAL__ui_set_image = (payload: Payload): PayloadAction<Payload> => ({
  type: ENUM__redux_action.UI_SET_IMAGE,
  payload,
});

export function INIT_LOCAL__ui_set_image(state: STATE__ui, action: PayloadAction<Payload>) {
  let { key, value } = action.payload;

  let value_old = state[key];

  assert_instanceof(value_old, DTO__image_asset);

  (state as any)[key] = value.clone();
}
